import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { PersonGbMasterDetailEntryMeta, PersonGbVersionDetailEntryMeta } from '../../../../core/gb-api';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { DayMonthYearDatePipe } from '../../../../shared/pipes/simple/dayMonthYearDate.pipe';
import { FormatUidPipe } from '../../../../shared/pipes/format/format-uid.pipe';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';

@Component({
  selector: 'cap-persongb-natuerliche-person',
  templateUrl: './persongb-natuerliche-person.component.html',
  styleUrls: ['./persongb-natuerliche-person.component.scss'],
  imports: [KopfdatenelementComponent, KompaktTimepointComponent, TranslatePipe, DayMonthYearDatePipe, FormatUidPipe, TranslateNamePipe]
})
export class PersongbNatuerlichePersonComponent implements OnInit {
  @Input()
  public version: PersonGbVersionDetailEntryMeta;
  @Input()
  public master: PersonGbMasterDetailEntryMeta;

  constructor(public translate: TranslateService) {
    keysToTranslate<string>([
      'Personalien',
      'WeitereVornamen',
      'Heimatort',
      'NameDerEltern',
      'NameEhegatte',
      'Geschlecht',
      'Zivilstand',
      'Nationalitaet',
      'Personengruppe',
      'Sprache',
      'Anrede',
      'UidStatus',
      'Gueltig',
      'Adressen'
    ]);
  }

  ngOnInit() {}
}
